import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const WoodenBlinds = () => {
    const whatWeOfferRef = useRef(null); 
          
            const scrollToSection = () => {
              if (whatWeOfferRef.current) {
                whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
              }
            };
  const features = [
    {
      title: "Light Control",
      description:
        "Easily adjust light levels with wooden slats for perfect ambiance and privacy.",
    },
    {
      title: "Timeless Design",
      description:
        "Elegant wooden blinds bring a natural warmth to your home, complementing any decor style.",
    },
    {
      title: "Durability",
      description:
        "Made from high-quality wood, ensuring long-lasting beauty and performance.",
    },
    {
      title: "UV Protection",
      description:
        "Block harmful UV rays while still allowing natural light into your space.",
    },
    {
      title: "Energy Efficiency",
      description:
        "Wooden blinds help improve insulation and reduce energy costs, keeping your home comfortable.",
    },
    {
      title: "Custom Fit",
      description:
        "Tailored to your window dimensions, ensuring a perfect fit for any room.",
    },
  ];
  
  const [activeIndex, setActiveIndex] = useState(null);
  
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  return (
    <div className='font-playfair'>
      
<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-32 text-center "
   style={{ backgroundImage: "url('images/wooden3.jpg')" }}
 >
  <div className=" sm:px-16 lg:px-24">
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    Wooden 
    </h1>
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
      Blinds
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-black bg-[#fff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>


      <div className="flex flex-col xl:gap-20  xl:px-20">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-2xl md:text-8xl 2xl:text-9xl font-extrabold text-gray-900 mb-8 ">Wooden Blinds</h1>
        </header>

        {/* About Wooden Blinds */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are Wooden Blinds?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          Wooden blinds are timeless and elegant window treatments that offer both 
          aesthetic appeal and functionality. Made from durable wood, they enhance privacy,
           control light, and contribute to a cozy, natural atmosphere in any room.
          </p>
        </section>

        {/* Benefits of Wooden Blinds */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            Wooden blinds provide a sophisticated and practical solution for controlling light, privacy, and energy efficiency. The natural texture of wood adds warmth and elegance to any space, while offering versatility and easy maintenance.

            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of Wooden Blinds</h2>

        </section>

        {/* How Wooden Blinds Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do Wooden Blinds Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          Wooden blinds operate by tilting the slats to adjust the amount of light that enters the room.
           Whether you need complete darkness or just a gentle flow of natural light, these blinds offer
            an effortless way to create the ideal ambiance.
          </p>
        </section>
        </div>

 {/* Content Section */}
 <section className="py-16 px-2 md:px-6">
  <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
    Transform Your Space with <br/>Motorized Blinds
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Effortless Morning Comfort</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day with the natural beauty of wooden blinds, which gradually let in the light, 
        creating a gentle sunrise effect. Perfect for waking up refreshed and energized,
         with a comfortable and soothing atmosphere.
        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/wooden2.jpg"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Customized Comfort Throughout the Day</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Wooden blinds give you control over your space, whether you need sunlight during 
        the day or a cozy, dimmed atmosphere. Adjust them easily to suit your needs, whether it's
         for work or relaxation.

        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/wooden3.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Evening Elegance</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Set the mood for your evening with wooden blinds. Adjust them to achieve the perfect level
         of privacy and light, creating a relaxed and elegant atmosphere for any gathering or quiet night in.

        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/wooden.jpg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>

      {/* Features */}
      <section className="mb-16 bg-white p-8 max-w-6xl mx-auto xl:pt-20">
        <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
          Key Features of Wooden Blinds
        </h2>
        <div>
          {features.map((feature, index) => (
            <div
              key={index}
              className="border-b border-gray-400 p-3 mb-4 "
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
                  {feature.title}
                </h3>
                <button
                  className="text-xl md:text-4xl font-bold text-gray-600"
                  aria-label="Toggle FAQ"
                >
                  {activeIndex === index ? "-" : "+"}
                </button>
              </div>
              {activeIndex === index && (
                <p className="text-gray-600 mt-2 text-base md:text-4xl">{feature.description}</p>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WoodenBlinds;

// import React, { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);

// const WoodenBlinds = () => {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       gsap.from('.wood-content', {
//         scrollTrigger: {
//           trigger: '.wood-content',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         y: 50,
//         opacity: 0,
//         duration: 1,
//         stagger: 0.2
//       });

//       gsap.from('.wood-gallery-item', {
//         scrollTrigger: {
//           trigger: '.wood-gallery',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         y: 30,
//         opacity: 0,
//         duration: 0.8,
//         stagger: 0.15
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   const woodTypes = [
//     { name: 'Premium Oak', color: '#d4a161', image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' },
//     { name: 'Rich Mahogany', color: '#8b4513', image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' },
//     { name: 'Classic Pine', color: '#deb887', image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' },
//     { name: 'Elegant Walnut', color: '#8b7355', image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80' }
//   ];

//   return (
//     <section ref={sectionRef} className="py-20 bg-[#f8f5f0]">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-4xl font-bold text-[#3c2915] mb-4">Wooden Blinds</h2>
//           <p className="text-xl text-[#6b4423] max-w-2xl mx-auto">
//             Bring the warmth and beauty of natural wood into your space
//           </p>
//         </div>

//         <div className="wood-content grid md:grid-cols-2 gap-12 mb-20">
//           <div className="relative">
//             <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
//               <img
//                 src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//                 alt="Wooden Blinds Showcase"
//                 className="w-full h-full object-cover"
//               />
//             </div>
//             <div className="absolute -bottom-6 -right-6 bg-[#3c2915] text-white p-6 rounded-xl shadow-xl max-w-xs">
//               <p className="text-lg font-semibold mb-2">Premium Quality</p>
//               <p className="text-sm opacity-90">Crafted from sustainably sourced hardwoods</p>
//             </div>
//           </div>

//           <div className="space-y-8">
//             <div className="bg-white p-8 rounded-xl shadow-lg">
//               <h3 className="text-2xl font-semibold text-[#3c2915] mb-4">Natural Beauty</h3>
//               <p className="text-[#6b4423] mb-6">
//                 Each blind is unique, showcasing the natural grain patterns and textures of premium hardwoods
//               </p>
//               <img
//                 src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                 alt="Wood Texture"
//                 className="w-full h-48 object-cover rounded-lg"
//               />
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div className="bg-white p-6 rounded-xl shadow-lg">
//                 <img
//                   src="https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                   alt="Installation"
//                   className="w-full h-32 object-cover rounded-lg mb-4"
//                 />
//                 <h4 className="text-lg font-semibold text-[#3c2915]">Easy Installation</h4>
//               </div>

//               <div className="bg-white p-6 rounded-xl shadow-lg">
//                 <img
//                   src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                   alt="Maintenance"
//                   className="w-full h-32 object-cover rounded-lg mb-4"
//                 />
//                 <h4 className="text-lg font-semibold text-[#3c2915]">Low Maintenance</h4>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="wood-gallery mb-20">
//           <h3 className="text-3xl font-bold text-[#3c2915] text-center mb-12">Wood Types</h3>
//           <div className="grid md:grid-cols-4 gap-6">
//             {woodTypes.map((wood, index) => (
//               <div key={index} className="wood-gallery-item group">
//                 <div className="relative aspect-[3/4] rounded-xl overflow-hidden shadow-lg mb-4">
//                   <img
//                     src={wood.image}
//                     alt={wood.name}
//                     className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//                   />
//                   <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-40 transition-opacity duration-300" />
//                 </div>
//                 <div className="flex items-center space-x-3">
//                   <div className="w-6 h-6 rounded-full" style={{ backgroundColor: wood.color }} />
//                   <span className="text-[#3c2915] font-semibold">{wood.name}</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="wood-gallery grid grid-cols-2 md:grid-cols-3 gap-4">
//           {[1, 2, 3, 4, 5, 6].map((item) => (
//             <div key={item} className="wood-gallery-item relative aspect-square rounded-xl overflow-hidden shadow-lg">
//               <img
//                 src={`https://images.unsplash.com/photo-${item % 2 === 0 ? '1513519245088-0e12902e35a0' : '1484154218962-a197022b5858'}?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80`}
//                 alt={`Installation ${item}`}
//                 className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
//                 <p className="text-white font-semibold">Installation Example {item}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WoodenBlinds;